
var scrollFinished;
var resizeFinished;
var calculateHeaderPos = true;

/*site and site width */
const fs = document.getElementById('frameSite');
var wwidth = 0;
var gwidth = 0;
var wwidthStorage = 0;
var gwidthStorage = 0;

/* header */
const fh = document.getElementById('frameHeader');
const fb = document.getElementById('frameBooking');
const bookingHight = 34;
var headerHeight = 140;
var filterHeight = 0;
var offsetCorrection = 115;
var wstStore = 0;
var wstSync = 0;
var isSync = false;
var isStart = true;
var isBlock = false;
var isRestart = false;

/* main nav */
const mg = document.getElementById('maskGrey');
const mnd = document.getElementById('mainNavDrawer'); 
const mnc = document.getElementById('mainNavClose');
const elul = document.getElementById('firstUlFrame');
const burger = document.getElementById('burger');




/* -- functions position head ----------------------------------------------------*/
function headerBookingFilterHigh() {
  headerHeight = fh.offsetHeight;
  filterHeight = 0;
  offsetCorrection = bookingHight + headerHeight + filterHeight;
}

function scrollPosHeadFilter() {
  let wiw = window.innerWidth;
  if (wiw>1280) {
	wwidth = 3;
	gwidth = 2;
  }
  if ((wiw>1000)&&(wiw<1281)) {
    wwidth = 2;
	gwidth = 2;
  }
  if ((wiw>600)&&(wiw<1001)) {
    wwidth = 1;
	gwidth = 1;
  }
  if (wiw<601) {
    wwidth = 0;
	gwidth = 0;
  }
  let wst = Math.round( window.scrollY );
  if (wst < 0) { wst = 0; }  
  if (wst > 11) {
    fh.classList.add('headBorder');
  } else {
    fh.classList.remove('headBorder');
  }
  let none = bookingHight-headerHeight; 
  let fht = none;
  if (isBlock) {
	fh.style.top = none+'px';
    isSync = false;
	wstStore = wst;
  } else {
	if (isSync) {
	  let sp = none+(wstSync-wst);
	  if (sp<none) {  // komplett eingefahren, gelöst
		isSync = false;
		fht = none;
	  }
	  if ((sp>=none)&&(sp<=bookingHight)) { // teilweise eingefahren, verbunden
		fht = sp;
	  }
	  if (sp>bookingHight) { // ausgefahren, verbunden, verschiebt sich
		wstSync = wst+headerHeight;
		fht = bookingHight;
	  }
	}
	if (isStart) { // startet ausgefahren, verbunden, verschiebt sich
      if (wst < headerHeight) {
  	    setTimeout(function() {
          window.scrollTo({
		    top: 0,
		    behavior: "smooth"
          });
        }, 100);
      }
	  isStart = false;
	  wstSync = wst+headerHeight;
	  fht = bookingHight;
	  isSync = true;
	}
	if (isRestart) {  // startet komplett eingefahren, gelöst
	  isRestart = false;
	  wstSync = wst;
	  fht = none;
	  isSync = false;
	}
	fh.style.top = fht+'px';
	if (!isSync) {
	  if (wstStore>wst) {
		isSync = true;
		wstSync = wst;
	  }
	}
	wstStore = wst;
  }
} 

/* -- functions navigation ----------------------------------------------*/
function closeOneSecondNav(el) {
  elul.classList.add('navFade', 'secondFade');
  el.parentElement.classList.remove('hasOut');
  setTimeout(() => {
	el.classList.remove('open', 'out');
	elul.classList.remove('shrink', 'navFade', 'secondFade');
  }, 300);
}
  
function closeAllSecondThirdNav() {
  document.querySelectorAll('.firstButton').forEach(el => {
	if (el.classList.contains('open')) {
      closeOneSecondNav(el);
	}
  });
  document.querySelectorAll('.secondButton').forEach(elpa => {
	elpa.classList.remove('open');
  });
  document.querySelectorAll('.menuAccordionBody').forEach(elbu => {
	elbu.classList.remove('open');
  });
}


/* -- after rezise ------------------------------------------------------*/
function changeGridAfterRezize() {
  if (gwidth != gwidthStorage) {
    if (gridIsSort) {
      resortGridItems();
      setTimeout(() => { sortGridItems(); }, 50);
    }
    gwidthStorage = gwidth;
  }
}


/* -- load on start -----------------------------------------------------*/

  /* burger open main nav */
  document.getElementById('burger').addEventListener('click', () => {
	if (!mnd.classList.contains('active')) {
	  mg.classList.add('active', 'grey');
	  mnd.classList.add('active');
	}
  });
  
  /* grey mask close main nav */
  mg.addEventListener('click', () => {
    if (mg.classList.contains('active')) {
      setTimeout(() => { mg.classList.remove('grey'); }, 200);
      setTimeout(() => { mg.classList.remove('active'); }, 400);
      mnd.classList.remove('active');
      closeAllSecondThirdNav();
	}
  });
  
  /* nav cross close main nav */
  mnc.addEventListener('click', () => {
	if (mg.classList.contains('active')) {
	  setTimeout(() => { mg.classList.remove('grey'); }, 200);
	  setTimeout(() => { mg.classList.remove('active'); }, 400);
	  mnd.classList.remove('active');
      closeAllSecondThirdNav();
	}
  });

  /* first nav link - stop link and open second nav items */
  document.querySelectorAll('.firstLinkSub').forEach(item => {
	item.addEventListener('click', function(e) {
	  e.preventDefault();
	  var elpa = this.parentElement;
	  document.querySelectorAll('.firstButton').forEach(el => {
		if (el !== elpa) {
          closeOneSecondNav(el);
        }
	  });
	  if (elpa.classList.contains('open')) {
        closeOneSecondNav(elpa);
      } else {
        let isOpen = false;		  
        document.querySelectorAll('.firstButton').forEach(el => {
          if (el.classList.contains('open')) { isOpen = true; }
        });
		if (isOpen) {  // öffnen wenn andere offen
		  elul.classList.add('navFade');
		  elul.classList.add('secondFade');
		  setTimeout(() => {
			elpa.classList.add('open', 'out');
			elpa.parentElement.classList.add('hasOut');
			elul.classList.add('shrink');
			elul.classList.remove('navFade', 'secondFade');
		  }, 300);
		} else {    // schneller öffnen wenn nicht andere offen
		  elul.classList.add('now', 'navFade', 'secondFade');
		  setTimeout(() => {
			elpa.classList.add('out');
			elpa.parentElement.classList.add('hasOut');
			elul.classList.remove('now', 'secondFade');
		  }, 10);
		  setTimeout(() => {
			elpa.classList.add('open');
			elul.classList.add('shrink');
			elul.classList.remove('navFade');
		  }, 300);
		}
	  }
	});
  });
  
  /* return button to first nav items on mobile */
  document.querySelectorAll('.secondTitle').forEach(elba => {
    elba.addEventListener('click', function(event) {
      elul.classList.add('navFade');
      setTimeout(() => {
        document.querySelectorAll('.firstButton').forEach(el => {
		  el.classList.remove('open','out');
	    });
        document.querySelectorAll('.secondButton').forEach(elpa => {
		  elpa.classList.remove('open');
	    });
        document.querySelectorAll('.menuAccordionBody').forEach(elbu => {
		  elbu.classList.remove('open');
	    });
        elul.classList.remove('shrink', 'navFade', 'secondFade');
      }, 300);
    });
  });
  
  /*Bei Klick auf zweite Navigationspunkte Links verhindern und dritte Ebene ausklappen */
  document.querySelectorAll('.secondLinkSub').forEach(item => {
	item.addEventListener('click', function(e) {
	  e.preventDefault();
	  var elbu = this.parentElement.parentElement.querySelector('.menuAccordionBody');
	  var elpa = this.parentElement;
	  if (elbu.classList.contains('open')) {
		elbu.classList.remove('open');
		elpa.classList.remove('open');
      } else {
		elbu.classList.add('open');
		elpa.classList.add('open');
      }
	});
  });  
    
  
/* Scroll */
window.addEventListener('scroll', () => {
  // while scrolling
  if (calculateHeaderPos) { scrollPosHeadFilter(); }
  
  clearTimeout(scrollFinished);
  scrollFinished = setTimeout(function() {
	// after scrolling

  }, 200);
});


/* Rezize */
window.addEventListener('resize', () => {
  // while resize
	
  clearTimeout(resizeFinished);
  resizeFinished = setTimeout(function() {
	// after resize
	headerBookingFilterHigh();
    setTimeout(() => { if (calculateHeaderPos) { scrollPosHeadFilter(); } }, 5);
	if (document.querySelector('.basicLightbox')!==null) { fitBasicLightbox(); }
	setTimeout(() => { changeGridAfterRezize(); }, 10);
	
  }, 200);
});


  /* toggle all accordions */
  if (document.querySelectorAll('.accordionHeader').length > 0) {
	document.querySelectorAll('.accordionHeader').forEach(header => {
	  header.addEventListener('click', () => {
		let thisBody = header.parentElement.querySelector('.accordionBody');
		header.classList.toggle('out');
		thisBody.classList.toggle('out');
	  });
	});
  }

